/**
 * Parses a date field from the API, tolerating both formats it has served.
 *
 * The post types' `publishAt`/`createdAt` now resolve through `isoDate` on the server and emit
 * ISO 8601, because the iOS and Android clients parse ISO and could not read the epoch-millis
 * string Nexus produced before. This helper accepts either, so the admin screens keep working
 * either side of that backend deploy rather than showing "Invalid Date" in the window between
 * the two — and so any endpoint still emitting millis doesn't break them.
 */
export const parseApiDate = (value: string | number | null | undefined): Date | null => {
    if (value == null || value === '') return null;
    // All-digits means epoch milliseconds; `new Date("1787711273542")` is an Invalid Date,
    // whereas `new Date(1787711273542)` is the timestamp.
    const asString = String(value);
    const date = /^\d+$/.test(asString) ? new Date(Number(asString)) : new Date(asString);
    return Number.isNaN(date.getTime()) ? null : date;
};
